// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3xfuN","productName":"Table_productName__2gICB"};